"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputCode = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

/* eslint-disable @typescript-eslint/no-unused-vars */
var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var InputCode = function InputCode(_ref) {
  var size = _ref.size,
      style = _ref.style,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      onChange = _ref.onChange,
      boxColor = _ref.boxColor,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["size", "style", "value", "onChange", "boxColor"]);
  // eslint-disable-next-line no-unused-vars
  var classes = useStyles(); // convert characters into words, to have a nice caret experience

  var prepareValue = function prepareValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return value.split('').filter(function (character) {
      return character != ' ';
    }).slice(0, size).join(' ');
  };

  var _useState = (0, React.useState)(prepareValue(value)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      preparedValue = _useState2[0],
      setPreparedValue = _useState2[1];

  React.useEffect(function () {
    setPreparedValue(prepareValue(value)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  var handleChange = function handleChange(event) {
    setPreparedValue(prepareValue(event.target.value));
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };

  var fillColor = (boxColor || 'rgb(249, 249, 249)').replace('#', '%23');
  var inlineStyle = {
    // eslint-disable-next-line max-len
    backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" width=\\\"42\\\" height=\\\"32\\\"><rect style=\\\"fill: ".concat(fillColor, "\\\" width=\\\"32\\\" height=\\\"32\\\" rx=\\\"3\\\" /></svg>\")"),
    width: 32 * size + 10 * (size - 1)
  }; // allow inline css being passed as a prop, we merge it with ours, so we don't override it

  Object.assign(inlineStyle, style);
  return /*#__PURE__*/React.createElement("input", (0, _extends2["default"])({
    className: "InputCode"
  }, rest, {
    type: "text",
    style: inlineStyle,
    maxLength: size * 2 - 1,
    value: preparedValue,
    onChange: handleChange
  }));
};

exports.InputCode = exports["default"] = InputCode;
//# sourceMappingURL=index.js.map